/**
 * The one page header: H1, an optional single line of context below it, and
 * the page's actions on the right.
 *
 * Every page uses this instead of hand-writing `.page-head`, and no page CSS
 * restyles it — one title size, one spacing, everywhere. Keep `sub` to facts
 * the user needs (scope, data freshness); a page title does not need a tagline.
 */

import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: ReactNode;
  /** One short line of context, e.g. "Stand 14:32". Optional — most pages need none. */
  sub?: ReactNode;
  /** Buttons, status, spinners — right-aligned, wraps below on narrow screens. */
  actions?: ReactNode;
}

export function PageHeader({ title, sub, actions }: PageHeaderProps): ReactNode {
  return (
    <div className="page-head">
      <div className="page-head-text">
        <h1>{title}</h1>
        {sub ? <div className="page-sub">{sub}</div> : null}
      </div>
      {actions ? <div className="toolbar">{actions}</div> : null}
    </div>
  );
}

export default PageHeader;
